// Generated by BUCKLESCRIPT, PLEASE EDIT WITH CARE
'use strict';

var Block = require("bs-platform/lib/js/block.js");
var Curry = require("bs-platform/lib/js/curry.js");
var BigInteger = require("big-integer");
var Imandra_prelude = require("imandra-prelude/src-bs/imandra_prelude.bs.js");

function value(param, param$1) {
  var match = param.grid;
  switch (param$1) {
    case /* A */0 :
        return match.a;
    case /* B */1 :
        return match.b;
    case /* C */2 :
        return match.c;
    case /* D */3 :
        return match.d;
    case /* E */4 :
        return match.e;
    case /* F */5 :
        return match.f;
    case /* G */6 :
        return match.g;
    case /* H */7 :
        return match.h;
    case /* I */8 :
        return match.i;
    
  }
}

function is_winning(param, player) {
  var match = param.grid;
  var i = match.i;
  var h = match.h;
  var g = match.g;
  var f = match.f;
  var e = match.e;
  var d = match.d;
  var c = match.c;
  var b = match.b;
  var a = match.a;
  var winning_state_000 = player;
  var winning_state_001 = player;
  var winning_state_002 = player;
  var winning_state = /* tuple */[
    winning_state_000,
    winning_state_001,
    winning_state_002
  ];
  if (Imandra_prelude.$eq(/* tuple */[
          a,
          b,
          c
        ], winning_state) || Imandra_prelude.$eq(/* tuple */[
          d,
          e,
          f
        ], winning_state) || Imandra_prelude.$eq(/* tuple */[
          g,
          h,
          i
        ], winning_state) || Imandra_prelude.$eq(/* tuple */[
          a,
          d,
          g
        ], winning_state) || Imandra_prelude.$eq(/* tuple */[
          b,
          e,
          h
        ], winning_state) || Imandra_prelude.$eq(/* tuple */[
          c,
          f,
          i
        ], winning_state) || Imandra_prelude.$eq(/* tuple */[
          a,
          e,
          i
        ], winning_state)) {
    return true;
  } else {
    return Imandra_prelude.$eq(/* tuple */[
                c,
                e,
                g
              ], winning_state);
  }
}

function other_player(param) {
  if (param) {
    return /* X */0;
  } else {
    return /* O */1;
  }
}

function move_counts(param) {
  return Imandra_prelude.List.fold_right((function (el, param) {
                var o = param[1];
                var x = param[0];
                if (el !== undefined) {
                  if (el) {
                    return /* tuple */[
                            x,
                            Imandra_prelude.$plus(o, BigInteger(1))
                          ];
                  } else {
                    return /* tuple */[
                            Imandra_prelude.$plus(x, BigInteger(1)),
                            o
                          ];
                  }
                } else {
                  return /* tuple */[
                          x,
                          o
                        ];
                }
              }), /* tuple */[
              BigInteger(0),
              BigInteger(0)
            ], /* :: */[
              param.a,
              /* :: */[
                param.b,
                /* :: */[
                  param.c,
                  /* :: */[
                    param.d,
                    /* :: */[
                      param.e,
                      /* :: */[
                        param.f,
                        /* :: */[
                          param.g,
                          /* :: */[
                            param.h,
                            /* :: */[
                              param.i,
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function is_valid_grid(grid, last_player) {
  var match = move_counts(grid);
  var o = match[1];
  var x = match[0];
  if (Imandra_prelude.$plus(x, o).equals(BigInteger(0)) && Imandra_prelude.$eq(last_player, undefined) || Imandra_prelude.$neg(x, o).equals(BigInteger(1)) && Imandra_prelude.$eq(last_player, /* X */0)) {
    return true;
  } else if (x.equals(o)) {
    return Imandra_prelude.$eq(last_player, /* O */1);
  } else {
    return false;
  }
}

function is_tie(param) {
  var match = param.grid;
  return Imandra_prelude.List.for_all((function (param) {
                return Imandra_prelude.$less$great(undefined, param);
              }), /* :: */[
              match.a,
              /* :: */[
                match.b,
                /* :: */[
                  match.c,
                  /* :: */[
                    match.d,
                    /* :: */[
                      match.e,
                      /* :: */[
                        match.f,
                        /* :: */[
                          match.g,
                          /* :: */[
                            match.h,
                            /* :: */[
                              match.i,
                              /* [] */0
                            ]
                          ]
                        ]
                      ]
                    ]
                  ]
                ]
              ]
            ]);
}

function is_valid_game(game) {
  var winning_X = is_winning(game, /* X */0);
  var winning_O = is_winning(game, /* O */1);
  if (is_valid_grid(game.grid, game.last_player)) {
    if (Imandra_prelude.not(winning_X) && Imandra_prelude.not(winning_O)) {
      return true;
    } else {
      return Imandra_prelude.$less$great(winning_X, winning_O);
    }
  } else {
    return false;
  }
}

function is_valid_move_broken(game, player, _move) {
  if (Imandra_prelude.not(is_winning(game, /* X */0) || is_winning(game, /* O */1) || is_tie(game)) && is_valid_game(game)) {
    if (Imandra_prelude.$eq(game.last_player, undefined) && Imandra_prelude.$eq(player, /* X */0)) {
      return true;
    } else {
      return Imandra_prelude.$eq(game.last_player, player ? /* X */0 : /* O */1);
    }
  } else {
    return false;
  }
}

function is_valid_move(game, player, move) {
  if (Imandra_prelude.not(is_winning(game, /* X */0) || is_winning(game, /* O */1) || is_tie(game)) && is_valid_game(game) && (Imandra_prelude.$eq(game.last_player, undefined) && Imandra_prelude.$eq(player, /* X */0) || Imandra_prelude.$eq(game.last_player, player ? /* X */0 : /* O */1))) {
    return Imandra_prelude.$eq(value(game, move), undefined);
  } else {
    return false;
  }
}

function play_move(param, player, move) {
  var grid = param.grid;
  var play = player;
  var grid$1;
  switch (move) {
    case /* A */0 :
        grid$1 = {
          a: play,
          b: grid.b,
          c: grid.c,
          d: grid.d,
          e: grid.e,
          f: grid.f,
          g: grid.g,
          h: grid.h,
          i: grid.i
        };
        break;
    case /* B */1 :
        grid$1 = {
          a: grid.a,
          b: play,
          c: grid.c,
          d: grid.d,
          e: grid.e,
          f: grid.f,
          g: grid.g,
          h: grid.h,
          i: grid.i
        };
        break;
    case /* C */2 :
        grid$1 = {
          a: grid.a,
          b: grid.b,
          c: play,
          d: grid.d,
          e: grid.e,
          f: grid.f,
          g: grid.g,
          h: grid.h,
          i: grid.i
        };
        break;
    case /* D */3 :
        grid$1 = {
          a: grid.a,
          b: grid.b,
          c: grid.c,
          d: play,
          e: grid.e,
          f: grid.f,
          g: grid.g,
          h: grid.h,
          i: grid.i
        };
        break;
    case /* E */4 :
        grid$1 = {
          a: grid.a,
          b: grid.b,
          c: grid.c,
          d: grid.d,
          e: play,
          f: grid.f,
          g: grid.g,
          h: grid.h,
          i: grid.i
        };
        break;
    case /* F */5 :
        grid$1 = {
          a: grid.a,
          b: grid.b,
          c: grid.c,
          d: grid.d,
          e: grid.e,
          f: play,
          g: grid.g,
          h: grid.h,
          i: grid.i
        };
        break;
    case /* G */6 :
        grid$1 = {
          a: grid.a,
          b: grid.b,
          c: grid.c,
          d: grid.d,
          e: grid.e,
          f: grid.f,
          g: play,
          h: grid.h,
          i: grid.i
        };
        break;
    case /* H */7 :
        grid$1 = {
          a: grid.a,
          b: grid.b,
          c: grid.c,
          d: grid.d,
          e: grid.e,
          f: grid.f,
          g: grid.g,
          h: play,
          i: grid.i
        };
        break;
    case /* I */8 :
        grid$1 = {
          a: grid.a,
          b: grid.b,
          c: grid.c,
          d: grid.d,
          e: grid.e,
          f: grid.f,
          g: grid.g,
          h: grid.h,
          i: play
        };
        break;
    
  }
  return {
          grid: grid$1,
          last_player: play
        };
}

function status(game) {
  if (is_winning(game, /* X */0)) {
    return /* Won */Block.__(0, [/* X */0]);
  } else if (is_winning(game, /* O */1)) {
    return /* Won */Block.__(0, [/* O */1]);
  } else if (is_tie(game)) {
    return /* Tied */1;
  } else {
    return /* InProgress */0;
  }
}

function play(is_valid_fn, game, move) {
  var last_player = game.last_player;
  var player = last_player !== undefined && !last_player ? /* O */1 : /* X */0;
  if (Curry._3(is_valid_fn, game, player, move)) {
    var game$1 = play_move(game, player, move);
    return /* tuple */[
            game$1,
            status(game$1)
          ];
  } else {
    return /* tuple */[
            game,
            /* InvalidMove */Block.__(1, [move])
          ];
  }
}

var a_grid = {
  a: /* O */1,
  b: /* X */0,
  c: /* O */1,
  d: undefined,
  e: undefined,
  f: /* X */0,
  g: undefined,
  h: undefined,
  i: undefined
};

var initial_game = {
  grid: {
    a: undefined,
    b: undefined,
    c: undefined,
    d: undefined,
    e: undefined,
    f: undefined,
    g: undefined,
    h: undefined,
    i: undefined
  },
  last_player: undefined
};

var initial_player = /* X */0;

exports.a_grid = a_grid;
exports.initial_game = initial_game;
exports.initial_player = initial_player;
exports.value = value;
exports.is_winning = is_winning;
exports.other_player = other_player;
exports.move_counts = move_counts;
exports.is_valid_grid = is_valid_grid;
exports.is_tie = is_tie;
exports.is_valid_game = is_valid_game;
exports.is_valid_move_broken = is_valid_move_broken;
exports.is_valid_move = is_valid_move;
exports.play_move = play_move;
exports.status = status;
exports.play = play;
/* big-integer Not a pure module */
